import ScoreMap from './ScoreMap';

export default ScoreMap;
